import { AppState } from 'types/app';

export const selectSephora = (state: AppState) => state.sephora || {};

export const selectIsLoadingLoyalty = (state: AppState) => selectSephora(state).isLoading;

export const selectLoyaltyId = (state: AppState) => selectSephora(state).loyaltyId;

export const selectIsValidated = (state: AppState) => selectSephora(state).isValidated;

export const selectLoyaltyEmail = (state: AppState) => selectSephora(state).email;

export const selectLoyaltyError = (state: AppState) => selectSephora(state).error;
